<li class="nav-item">
    <button class="nav-link btn btn-warning text-white mr-2" (click)="postponeTurn()"><i class="fa fa-clock-o" aria-hidden="true"></i> {{ "postpone" | language }}</button>
</li>
